import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  TemplateRef
} from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../core/core.module';
import { ConfirmDialogData } from './confirm-dialog.interface';

@Component({
  selector: 'rpe-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  title: string;
  contentText: string;
  submitText: string;
  cancelText: string;
  cancelColor: string;
  submitColor: string;

  customTemplate: TemplateRef<any>;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  ngOnInit() {
    // this.customTemplate = this.data.contentText;
  }

  onSubmit() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}

export interface archivosTecnicoResponsable {
  cv: File;
  carta_recomendacion?: File;
}
